import React, { useState } from "react";
import Swal from "sweetalert2";
import { FaSearch, FaTrash } from "react-icons/fa";
import './add-extras.css';

function FormMissing() {

    const mockData = [
        {
          number: '111-12345678',
          type: 'directa',
          merchandiseType: 'Cont activos',
          pzas: 2,
          weight: 27.00,
          cliente: 'FedEx',
          fecha: '2025-04-10',
          origen: 'CMX',
          destino: 'GDL',
          cubiscan: 1,
          flightsArrive: [
            "AM0001/26MAR 2025", "AM1050/28MAR 2025"
          ],
        },
        {
          number: '222-87654321',
          type: 'parcial',
          merchandiseType: 'Carga general',
          pzas: 4,
          weight: 48.30,
          cliente: 'UPS',
          fecha: '2025-04-11',
          origen: 'MTY',
          destino: 'TIJ',
          cubiscan: 1,
          flightsArrive: [
            "AM0046/12MAR 2025", "AM1032/13APR 2025"
          ],
        }
    ];

    const [form, setForm] = useState({
        flight_arrive_select: '',
        pieces: '',
        weight: '',
    });
    const [awb, setAwb] = useState('');
    const [flightOptions, setFlightOptions] = useState([]);
    const [showError, setShowError] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleAwbChange = (e) => {
        let inputValue = e.target.value;

        inputValue = inputValue.replace(/\D/g, "");
        if (inputValue.length > 3 && inputValue[3] !== "-") {
            inputValue = inputValue.slice(0, 3) + "-" + inputValue.slice(3);
        }

        setAwb(inputValue);

        const found = mockData.find(item => item.number === inputValue);
        if (found) {
            setFlightOptions(found.flightsArrive);
        } else {
            setFlightOptions([]);
        }
    };

    const onlyAllowNumbers = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9.]/g, '');

        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts[1];
        }

        e.target.value = value;
    };

    const handleSearchMaster = () => {
        alert('Buscar');
    }
    
    const handleDeleteMaster = () => {
        alert('Borrar');
    }

    const handleSave = () => {
        const allFilled = awb !== '' && Object.values(form).every(value => value !== "");

        if (!allFilled) {
            setShowError(true);
        } else {
            setShowError(false);
            Swal.fire({
                title: "Alta generada con exito",
                icon: "success",
                iconColor: "#1B9925",
                customClass: {
                    confirmButton: "btn-ok",
                    title: "alert-title",
                    popup: "alert-bg",
                },
            });
            // Simulacion de envio al back
            const dataToSend = {
                awb: awb,
                flight_arrive_select: form.flight_arrive_select,
                pieces: form.pieces,
                weight: form.weight,
            };
            console.log("Datos preparados para backend:", dataToSend);
        }
    }
    
    return(
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label className="amc-label">Master*</label>
                    <div className="d-flex">
                        <input
                            type="text"
                            className="form-control"
                            name="awb"
                            value={awb}
                            onChange={handleAwbChange}
                        />
                        <button className="btn-search-awb" onClick={handleSearchMaster}>
                            <FaSearch />
                        </button>
                        <button className="btn-clean-awb" onClick={handleDeleteMaster}>
                            <FaTrash />
                        </button>
                    </div>
                    <small className="text-muted" style={{fontSize: '0.6rem'}}>
                        Clic en <b><FaSearch /></b> para buscar master existente
                    </small>
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label className="amc-label">Vuelo de llegada*</label>
                    <select 
                        className="form-select" 
                        name="flight_arrive_select"
                        id="flight_arrive_select"
                        value={form.flight_arrive_select}
                        onChange={handleChange}
                    >
                        <option disabled selected value="">Selecciona ...</option>
                        {flightOptions.map((flight, index) => (
                            <option key={index} value={flight}>{flight}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="pieces" class="amc-label">Piezas*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="pieces"
                        value={form.pieces}
                        onInput={onlyAllowNumbers}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="weight" class="amc-label">Peso*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="weight"
                        value={form.weight}
                        onInput={onlyAllowNumbers}
                        onChange={handleChange}
                    />
                </div>
            </div>
            {showError && (
                <div className="alert alert-danger mt-3">
                    Se han encontrado los siguientes errores:
                    <br />
                    <ul>
                        <li>Por favor llenar el formulario por completo</li>
                    </ul>
                </div>
            )}
            <div className="row">
                <div className="col mt-4 d-flex justify-content-end">
                    <button className='btnn' onClick={handleSave} >Guardar</button>
                </div>
            </div>
        </div>
    );
}

export default FormMissing;